import { render, staticRenderFns } from "./m-support-buttons.vue?vue&type=template&id=c3ea9720&scoped=true&lang=pug&"
import script from "./m-support-buttons.vue?vue&type=script&lang=js&"
export * from "./m-support-buttons.vue?vue&type=script&lang=js&"
import style0 from "./m-support-buttons.vue?vue&type=style&index=0&id=c3ea9720&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ea9720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
